var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomUnfoldLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-572q-9 0-17.5-3.5T447-586L310-723q-14-14-14-34t14-34q14-14 33-14t33 14l104 104 104-104q14-14 33.5-14t33.5 14q14 14 14 33.5T651-724L513-586q-7 7-15.5 10.5T480-572ZM310-170q-14-14-14-33.5t14-33.5l137-137q7-7 15.5-10.5T480-388q9 0 17.5 3.5T513-374l137 137q14 14 14.5 33.5T651-170q-14 14-34 14t-34-14L480-273 377-170q-14 14-33.5 14T310-170Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomUnfoldLess);
export default __webpack_public_path__ + "static/media/custom-unfold-less.ba7756785e4535bd9346b78dfb87c60b.svg";
export { ForwardRef as ReactComponent };